module.exports = __webpack_public_path__ + "img/gzhsuncode.5ce5d550.jpg";